import { gql } from '@apollo/client';

export const GET_SIGN_IN_STRATEGY_QUERY = gql`
  query GetSignInStrategyQuery {
    getSignInStrategy {
      strategies
      privilegedUserIds
    }
  }
`;
